export default "__VITE_ASSET__BJn7a4MR__"